module.exports = __webpack_public_path__ + "static/img/banner_journey@2x.ebff3ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/journey/banner_journey@2x.jpg
// module id = 7HxT
// module chunks = 1